import {
  ApplicationConfig,
  ErrorHandler,
  importProvidersFrom,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter,withComponentInputBinding } from '@angular/router';
import { routes } from './app.routes';
import { inboxCountInterceptor } from './interceptor/inbox-count-interceptor';

import {
  provideHttpClient,
  withInterceptorsFromDi,
  withNoXsrfProtection,
  HTTP_INTERCEPTORS,
  withInterceptors,
} from '@angular/common/http';

import { CookieService } from 'ngx-cookie-service';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { provideAnimations } from '@angular/platform-browser/animations';
import { CommonModule } from '@angular/common';

import { NgxUiLoaderModule, NgxUiLoaderHttpModule } from 'ngx-ui-loader';
import { AuthInterceptorInterceptor } from './interceptor/auth-interceptor-interceptor';
import { ErrorInterceptor } from './interceptor/error-interceptor';
import { FileSanitizeInterceptor } from './interceptor/file-sanitize-interceptor';
import { FeatureFlagInterceptor } from './interceptor/feature-flag-interceptor';

import { NgxGanttModule, GANTT_GLOBAL_CONFIG, GanttConfigService } from '@worktile/gantt';
import { CustomGanttConfigService } from './services/ganttService';
import { enUS } from 'date-fns/locale';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { LoadChunkErrorHandler } from './chache.service';

// import { NgxGanttModule } from '@worktile/gantt';
export const appConfig: ApplicationConfig = {
  providers: [
    { provide: GanttConfigService, useClass: CustomGanttConfigService },
    { provide: ErrorHandler, useClass: LoadChunkErrorHandler },
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),

    //  Enables all interceptors from DI
    provideHttpClient(
      withInterceptorsFromDi(),
      withNoXsrfProtection(),
      // withInterceptors([inboxCountInterceptor])
    ),

    //  Register your class-based interceptor
    {
      provide: HTTP_INTERCEPTORS,
      useClass: FeatureFlagInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorInterceptor,
      multi: true,
    },
     {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: FileSanitizeInterceptor,
      multi: true
    },

    provideAnimations(),

// importProvidersFrom(GanttModule)
    //  Import all modules (Material, Common, Loader)
    importProvidersFrom(
      CommonModule,
      MatSnackBarModule,
      NgxUiLoaderModule.forRoot({
        fgsType: 'square-jelly-box',
        fgsColor: '#f97316',
        pbColor: '#f97316',
        pbDirection: 'ltr',
        text: 'Please wait...',
        fgsSize: 70,
      }),

      // Foreground loader for HTTP; exclude fast/high-frequency reads so timesheet/dashboard feel snappier.
      NgxUiLoaderHttpModule.forRoot({
        showForeground: true,
        delay: 100,
        excludeRegexp: [
          '/project-timesheet/unreported-entries',
          '/project-timesheet/timesheet-data',
          '/bulk-upload/profile-upload-drafts',
          // My Team overview — section-level skeleton/shimmer (no full-screen overlay)
          '/my-team/projects-allocation-logged',
          '/my-team/workforce-overview',
          '/my-team/monthly-utilization-trend',
          '/assets/version.json',
          // Associate (client) portal — local shimmer only, never the full-screen loader
          '/associate/',
          // Staff notifications — bell panel + Inbox Threads local loading / reconnect refresh
          '/api/v1/notifications',
          '/ra/api/v1/notifications',
        ],
      }),
            NgCircleProgressModule.forRoot({
        radius: 100,
        showUnits: true,
        showSubtitle: false
      }),
      NgxGanttModule
    ),
          {
      provide: GANTT_GLOBAL_CONFIG,
      useClass: CustomGanttConfigService
    },

    CookieService,


    provideRouter(routes,withComponentInputBinding()),

  ],
};
